import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const LoadingState = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <FontAwesomeIcon
        icon={faSpinner}
        size="2x"
        className="animate-spin text-brand"
      />
    </div>
  );
};

export default LoadingState;
